<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,4C11,4,15,4,15,4C15.55,4,16,3.55,16,3C16,2.45,15.55,2,15,2C15,2,11,2,11,2C10.45,2,10,2.45,10,3C10,3.55,10.45,4,11,4C11,4,11,4,11,4ZM15,12C15,12,11.57,12,11.57,12C11.57,12,5.86,2.49,5.86,2.49C5.86,2.49,5.84,2.49,5.84,2.49C5.67,2.2,5.36,2,5,2C5,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3.55,0.45,4,1,4C1,4,4.43,4,4.43,4C4.43,4,10.14,13.51,10.14,13.51C10.14,13.51,10.15,13.5,10.15,13.5C10.33,13.8,10.64,14,11,14C11,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyOption',
} as DefineComponent
</script>
